"use strict";

class DeveloperPublicHolidaysController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;


        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.publicHolidays = null;
        self.selectedPublicHolidayDataset = null;
        self.publicHolidaysTotalCount = null;
        self.publicHolidaysPagesCount = null;

        self.publicHolidayParams = {
            country_code:parseInt(self.data.country_code),
            pageNo: '1',
            offset: 0,
            // Default 20 to match the smallest option in the "Show Rows" dropdown
            // (20 / 50 / 100). A value not in the dropdown left the select blank
            // on first load.
            limit: '20',
            send_total_count: true,
            order: '{"holiday_date":"asc"}',
        };

        self.publicHolidayViewMode = null;
        self.publicHolidayEditMode = null;

        self.getPublicHolidays();

    }

    //-------------------------------------------

    getPublicHolidays() {
        let self = this;

        let url = 'sec/developer/public-holidays';

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.publicHolidayParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.publicHolidays = response.data.public_holidays;
            self.publicHolidaysTotalCount = response.data.total_count;

            self.preparePublicHolidaysPaginationData();
        });

    }

    savePublicHoliday() {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self._savePublicHoliday();
        });
    }

    _savePublicHoliday() {
        let self = this;

        if (!self.publicHolidayParams) {
            return;
        }

        let url = 'sec/developer/public-holidays/';
        let params = angular.copy(self.publicHolidayParams);


        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#publicHolidayForm'))) {
            return;
        }
        params.holiday_date = self.SSUtilService.formatDateToStore(params.holiday_date);

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let existingPublicHoliday = self.selectedPublicHoliday;
            let newPublicHoliday = response.data;

            if (existingPublicHoliday && existingPublicHoliday.id) {
                angular.merge(existingPublicHoliday, newPublicHoliday);
            } else {
                self.publicHolidays.push(newPublicHoliday);
            }

            self.setPublicHolidayViewMode(false);
            self.setPublicHolidayViewMode(true,newPublicHoliday);
        };
        loading(true);
        if (self.publicHolidayParams.id) {
            url += self.publicHolidayParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deletePublicHoliday(publicHolidayId) {
        let self = this;

        if (!publicHolidayId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/public-holidays/'+ publicHolidayId + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    // Remove from local data
                    jQuery.each(self.publicHolidays, function (i, o) {
                        if (o.id == publicHolidayId) {
                            self.publicHolidays.splice(i, 1);
                            return false;
                        }
                    });

                    // If the deleted row is currently being viewed in detail, close the detail view.
                    if (self.selectedPublicHoliday && self.selectedPublicHoliday.id == publicHolidayId) {
                        self.setPublicHolidayViewMode(false);
                    }
                });
            }
        );
    }

    //-------------------------------------------

    setPublicHolidayViewMode(mode, publicHoliday) {
        const self = this;

        if (mode) {
            self.selectedPublicHoliday = publicHoliday;
            if (!self.selectedPublicHoliday) {
                self.setPublicHolidayEditMode(mode);
            }
        } else {
            self.selectedPublicHoliday = null;
            self.setPublicHolidayEditMode(mode);
        }

        self.publicHolidayViewMode = mode;
    }

    setPublicHolidayEditMode(mode) {
        const self = this;

        $('#holiday_date').datepicker({dateFormat: 'dd/mm/yy'});

        if (mode) {
            if (self.selectedPublicHoliday) {
                self.publicHolidayParams = angular.copy(self.selectedPublicHoliday);

                let holiday_date = self.publicHolidayParams.holiday_date;

                // Format Date Time to local string
                if(holiday_date){
                    self.publicHolidayParams.holiday_date = self.SSUtilService.formatUtcToLocalDate(holiday_date);
                }


            } else {
                self.publicHolidayParams = {};
            }
        } else {
            self.publicHolidayParams = {};
            if (!self.selectedPublicHoliday) {
                self.publicHolidayViewMode = mode;
            }
        }

        self.publicHolidayEditMode = mode;
    }

    countryChanged(){
        const self = this;
        // Reset paging when the filter changes — otherwise a stale offset
        // (e.g. page 5 of the previous country) is sent against the new,
        // possibly smaller, filtered set and returns an empty page.
        self.publicHolidayParams.pageNo = 1;
        self.publicHolidayParams.offset = 0;
        self.getPublicHolidays();
    }

    setPageNoAndLoadPublicHolidays(pageNo) {
        const self = this;
        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.publicHolidayParams.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.publicHolidayParams.pageNo - 1;
            }

            if (pageNo > self.publicHolidaysPagesCount) {
                pageNo = self.publicHolidaysPagesCount;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.publicHolidayParams.pageNo) {
                return; // Ignore if no change
            }

            self.publicHolidayParams.pageNo = pageNo;
        }

        self.publicHolidayParams.offset = (self.publicHolidayParams.pageNo - 1) * self.publicHolidayParams.limit;

        self.getPublicHolidays();
    }

    preparePublicHolidaysPaginationData() {
        const self = this;

        self.publicHolidaysPagesCount = Math.ceil(self.publicHolidaysTotalCount / self.publicHolidayParams.limit);
        self.publicHolidaysPagesArray = [];
        for (let i = 0; i < self.publicHolidaysPagesCount; i++) {
            self.publicHolidaysPagesArray.push(i + 1);
        }

        if (self.publicHolidaysPagesCount < self.publicHolidayParams.pageNo) {
            self.publicHolidayParams.pageNo = 1;
        }
    }
}

DeveloperPublicHolidaysController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('DeveloperPublicHolidaysController', DeveloperPublicHolidaysController);